/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::34dc4fdd748e48d54177385cb7b66bb3>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Component".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/component
 * Usage guidance:
 * Single purpose - Reserved for components in Jira and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const ComponentIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "ComponentIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.75A.75.75 0 0 1 2.75 2h3.5a.75.75 0 0 1 .75.75V4.5h2V2.75A.75.75 0 0 1 9.75 2h3.5a.75.75 0 0 1 .75.75V4.5a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6.5a2 2 0 0 1 2-2zM3.5 4.5h2v-1h-2zm9 0v-1h-2v1zM2 6a.5.5 0 0 0-.5.5V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6.5A.5.5 0 0 0 14 6z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
ComponentIcon.displayName = 'ComponentIcon';
var _default = exports.default = ComponentIcon;